import { getIsHighlighted } from './getIsHighlighted';
import { getGridPin } from '../../../constants/clusterPins/getGridPin';
import { IFeatureProperties } from '../../../types/map';
import { EMapItemZIndex } from '../../mapItemZIndex';

// Порядок наложения пинов раскрытого кластера:
// активный/ховер — выше всех; избранные — выше обычных; внутри уровня порядок задаёт
// zIndex слота (z-order слоёв из дизайна). Избранное берём по первому офферу фичи.
export function getBalloonZIndex(properties: IFeatureProperties, maxPinsPerCluster: number): number {
  if (getIsHighlighted(properties)) {
    return EMapItemZIndex.BALLOON_ACTIVE;
  }

  const base = getGridPin(properties.pinsCount, properties.pinIndex, maxPinsPerCluster)?.zIndex ?? 0;
  const level = properties.offers[0]?.isFavorite ? EMapItemZIndex.BALLOON_FAVORITE : EMapItemZIndex.BALLOON_DEFAULT;

  return level + base;
}
